import { render, staticRenderFns } from "./aboutPage.vue?vue&type=template&id=452fadc0&scoped=true"
import script from "./aboutPage.vue?vue&type=script&lang=js"
export * from "./aboutPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452fadc0",
  null
  
)

export default component.exports